export const MISSING_AUTH_SESSION_MESSAGE =
  "Tu sesion no esta activa en este navegador. Ingresa con tu correo y contrasena; tu registro y los terminos aceptados siguen guardados.";

export const isMissingAuthSessionError = (error) => {
  const message = typeof error === "string" ? error : error?.message || "";
  return error?.name === "AuthSessionMissingError" ||
    ["AUTH_SESSION_MISSING", "session_not_found", "refresh_token_not_found", "user_not_found"].includes(error?.code) ||
    /auth session missing|session from session_id claim.*does not exist|invalid refresh token.*not found/i.test(message) ||
    message === MISSING_AUTH_SESSION_MESSAGE;
};
